import ContractCargoTaxiUpdateRequest, {
  ContractCargoTaxiUpdateRequestBody,
} from "./contracts-cargo-taxi-update.request";

const createBody = (
  request: ContractCargoTaxiUpdateRequest,
): ContractCargoTaxiUpdateRequestBody => {
  return {
    disabled: request.disabled,
    contactPassengerAfterMinutes: request.contactPassengerAfterMinutes,
    cancelByTaxiAllowed: request.cancelOrderByTaxiAllowed,
    editByTaxiAllowed: request.editOrderByTaxiAllowed,
  };
};

const contractCargoTaxiUpdateRequestFactory = {
  createBody,
};

export default contractCargoTaxiUpdateRequestFactory;
